button.spellStatusButton.spellStatusButton {
  border: none;
  width: 48px;
  padding: 0;
  height: 100%;
  background: transparent;
  flex-shrink: 0;
  position: relative;

  &:disabled:hover {
    background: transparent;
    cursor: default;
  }

  > svg {
    fill: var(--color-accent);
    height: 24px;
    width: 24px;
    position: absolute;
    transition: opacity 300ms;
  }

  &:hover:not(:disabled) > svg {
    fill: var(--color-accent-hover);
  }

  &.leading.always_prepared svg:not(.iconAlwaysPrepared) {
    opacity: 0;
  }

  &.leading.prepared svg:not(.iconPrepared) {
    opacity: 0;
  }

  &.leading.known svg:not(.iconKnown) {
    opacity: 0;
  }

  &.leading.new svg:not(.iconNew) {
    opacity: 0;
  }
}

.dialog {
  max-width: 100vw;
  width: 360px;

  .dialogBody {
    h4 {
      margin-top: 0;
    }

    button {
      justify-content: flex-start;
      margin: 8px 0;

      svg {
        margin-right: 8px;
        fill: var(--color-accent);
        width: 24px;
        height: 24px;
      }
    }
  }
}
